import type { Environment } from '@change-corgi/config/environments';

import __googleTagManagerContainers from '../config/googleTagManagerContainers.json';

export const googleTagManagerContainerIds = __googleTagManagerContainers as Readonly<Record<Environment, string>>;
